import React from 'react';

const EventState = React.createContext({
    _refresh: () => null,
    state: {}
});

export default EventState;